import React from 'react';
import { Container, Box, Typography } from '@material-ui/core';
import { PharmacyOrder } from '@/types';

import { ButtonActions } from './ButtonActions';
import { HeaderLabel } from './HeaderLabel';
import { MedicineList } from './MedicineList';
import { PatientInfo } from './PatientInfo';
import { DeliveryInfo } from './DeliveryInfo';

interface Props {
  data: PharmacyOrder;
  updateOrderPharmacy: () => void;
}

export function ViewSuccess({ data, updateOrderPharmacy }: Props) {
  return (
    <Container
      style={{
        background: '#f7f9ff',
        padding: 0,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
      maxWidth="sm"
    >
      {/* ANCHOR: HEADER ------------------------------- */}
      <Box mb="1rem" bgcolor="white" p={2}>
        <HeaderLabel style={{ fontSize: 18, marginTop: 12, marginBottom: 24 }}>
          {data.pharmacy_name}
        </HeaderLabel>
        <Typography style={{ fontSize: 14, opacity: 0.7 }}>No Order</Typography>
        <Typography style={{ fontWeight: 700 }}>#{data.order_id}</Typography>
      </Box>

      {/* ANCHOR: IMPORTED COMPONENTS ------------------------------- */}
      <MedicineList
        list={data.products}
        onBidding={data.status === 'payment_successful'}
        earnings={data.pharmacy_total_price}
        pharmacistNotes={data.pharmacist_notes}
      />

      {data.status !== 'payment_successful' && (
        <>
          <PatientInfo
            patient={data.patient}
            patientAddress={data.is_self_pickup ? undefined : data.address}
            pharmacyAddress={
              data.is_self_pickup ? data.pharmacy_name : undefined
            }
          />
          <DeliveryInfo
            delivery={data.delivery}
            status={data.status}
            isSelfPickup={data.is_self_pickup}
          />
        </>
      )}

      {data.delivery.courier.is_error !== true && (
        <ButtonActions data={data} updateOrder={updateOrderPharmacy} />
      )}
    </Container>
  );
}
